// @ts-check
import { useMemo, useState } from 'react';

/**
 * @template DataType
 * @typedef {Object} SimpleTablePagerProps
 * @prop {DataType[]} data
 * @prop {number} pageSize
 */


/**
 * @callback onPerPageSelectCallback
 * @param {MouseEvent | React.MouseEvent<Element> | React.KeyboardEvent<Element>} event
 * @param {number} newPerPage
 * @param {number} newPage
 * @param {number} startIdx
 * @param {number} endIdx
 * @returns {void}
 */

/**
 * @callback onSetPageCallback
 * @param {MouseEvent | React.MouseEvent<Element> | React.KeyboardEvent<Element>} event
 * @param {number} newPage
 * @param {number} perPage
 * @param {number} startIdx
 * @param {number} endIdx
 * @returns {void}
 */

/**
 * @typedef {Object} PageInfo
 * @property {number} page
 * @property {number} perPage
 * @property {onSetPageCallback} onSetPage
 * @property {onPerPageSelectCallback} onPerPageSelect
 * @property {number} itemCount
 */

/**
 * Internal Pager helper for SimpleTable
 * @template DataType
 * @param {SimpleTablePagerProps<DataType>} props
 * @returns {PageInfo}
*/
const useSimpleTablePager = ({ data, pageSize: initalPageSize }) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(initalPageSize);
  return useMemo(() => ({
    page,
    perPage,
    itemCount: data?.length ?? 0,
    onSetPage: (_event, page) => setPage(page),
    onPerPageSelect: (_event, pageSize) => {
      setPerPage(pageSize);
    }
  }), [data, page, perPage]);
};

export default useSimpleTablePager;
